import { Dialog } from '@montugroup/design-system';
import { styled } from '@mui/material';

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiPaper-root': {
    width: '100%',
    height: '80vh',
    maxHeight: '80vh',
    margin: 'auto',
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    bottom: 0,
    position: 'fixed',
    borderTopLeftRadius: theme.spacing(6),
    borderTopRightRadius: theme.spacing(6),
    // We use 'sm' breakpoint since at width = 100%, the maxWidth of Dialog is 600px,
    // and it looks weird on some mobile devices.
    [theme.breakpoints.up('sm')]: {
      width: 1200,
      height: 'auto',
      margin: theme.spacing(8),
      borderRadius: theme.spacing(4),
      position: 'inherit',
    },
  },
}));
